module.exports = __webpack_public_path__ + "static/media/has_containers_half.a3adc159.svg";